var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon32PxBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 17.18V14c-.003-2.926-2.115-5.422-5-5.91V7c0-.552-.448-1-1-1s-1 .448-1 1v1.09c-2.885.488-4.997 2.984-5 5.91v3.18c-1.196.423-1.996 1.552-2 2.82v2c0 .552.448 1 1 1h3.14c.473 1.742 2.055 2.951 3.86 2.951 1.805 0 3.387-1.209 3.86-2.951H23c.552 0 1-.448 1-1v-2c-.004-1.268-.804-2.397-2-2.82zM12 14c0-2.21 1.79-4 4-4s4 1.79 4 4v3h-8v-3zm4 10c-.71-.004-1.365-.385-1.72-1h3.44c-.355.615-1.01.996-1.72 1zm6-3H10v-1c0-.552.448-1 1-1h10c.552 0 1 .448 1 1v1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon32PxBell);
export default __webpack_public_path__ + "static/media/4-icon-32-px-bell.e88af907.svg";
export { ForwardRef as ReactComponent };